module.exports = __webpack_public_path__ + "img/resources.0ecd900a.png";